import { inject } from 'vue';

export const injectListPage = () => {
    return inject('$list-page', {
        isSupported: () => false,
        openEditor: () => {},
        openComponent: () => {},
        openExport: () => {},
        openPrint: () => {},
        openCustom: () => {},
        clear: () => {},
        doSearch: () => {},
        loadPage: () => {},
        refresh: () => {}, // 保留原来的参数
        loadData: () => {}, // 按提供的参数加载数据
        reloadData: () => {}, // 重新加载数据
        // 获取表格数据
        getData: () => [],
        getCurrentRow: () => {},
        getCurrentId: () => '',
        deleteCurrentRow: () => {},
        deleteRow: () => {},
        editCurrentRow: () => {},
        editRow: () => {},
        // 打开配置的编辑器
        openEditorModal: () => {},
        // 打开自定义编辑器
        openCustomEditor: () => {},
        setCurrentRow: () => {},
        getTable: () => null,
        getRowId: () => '',
        getRowById: () => null,
        getRadioRow: () => null,
        getCheckboxRows: () => [],
        getSortColumns: () => [],
        remoteSortData: () => {},
        setSort: () => {},
        showAppendEditor: () => {},
        showCurrentUpdateEditor: () => {},
        showUpdateEditor: () => {},
    });
};
